import Tag from 'antd/lib/tag';
import 'antd/lib/tag/style/css';

export default Tag;
